import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

export type TLoadingActionType =
  'fullscreen' | 'fullscreenBlur' | 'layout' | 'layoutBlur';

type TLoadingStore = Record<`${TLoadingActionType}Count`, number>;

const getKey = (
  type: TLoadingActionType | undefined = 'fullscreen'
): `${TLoadingActionType}Count` => `${type}Count`;

const initialState: TLoadingStore = {
  fullscreenBlurCount: 0,
  fullscreenCount: 0,

  // Индикатор загрузки не перекрывающий header
  layoutBlurCount: 0,
  layoutCount: 0
};

const loadingSlice = createSlice({
  name: 'loadingSlice',
  initialState,
  reducers: {
    startGlobalLoading: (
      state,
      action: PayloadAction<TLoadingActionType | undefined>
    ) => {
      const key = getKey(action.payload);
      state[key] += 1;
    },
    stopGlobalLoading: (
      state,
      action: PayloadAction<TLoadingActionType | undefined>
    ) => {
      const key = getKey(action.payload);
      state[key] = Math.max(state[key] - 1, 0);
    },
    resetGlobalLoading: (
      state,
      action: PayloadAction<TLoadingActionType | undefined>
    ) => {
      const key = getKey(action.payload);
      state[key] = 0;
    }
  }
});

export const { startGlobalLoading, stopGlobalLoading, resetGlobalLoading } =
  loadingSlice.actions;

export default loadingSlice;
